import { ReactComponent as NTDet } from './icon_nt_det.svg';
import Icon, { IconProps } from './icon';

const IconNTDet = (props: IconProps) => {
  return <Icon {...props} Svg={NTDet} />;
};

export default IconNTDet;
